import {Injectable} from '@angular/core';
import {AuditService as ApiAuditService} from '../api/services/audit.service';
import {LookupModel} from '../api/models/lookup-model';
import {LookupService} from '../api/services';

@Injectable()
export class AuditService {

  constructor(
    private apiAuditService: ApiAuditService,
    private lookupService: LookupService,
  ) {
  }

  public async getAuditTypes(): Promise<LookupModel[]> {
    const response = await this.apiAuditService.auditGetAuditTypes().toPromise();
    for (const lookupModel of response) {
      lookupModel.id = lookupModel.intId?.toString();
    }
    return response;
  }

  public async getAuditCategories(): Promise<LookupModel[]> {
    const response = await this.apiAuditService.auditGetAuditCategories().toPromise();
    for (const lookupModel of response) {
      lookupModel.id = lookupModel.intId?.toString();
    }
    return response;
  }

  public async getAuditUsers(): Promise<LookupModel[]> {
    const response = await this.lookupService.lookupGetCustomerUsers({}).toPromise();

    return response.data;
  }
}
